import {defineStore, createPinia} from 'ui.vue3.pinia';
export const st = createPinia();
export const store = defineStore('basket', {
	state: () => ({
		basket:{
			total:null,
			items: null,
			unavailable: null,
			gifts: null
		},
		favorites:[],
		location: null
	}),
	getters: {
		countFavorites(){
			if(Array.isArray(this.favorites))
				return this.favorites.length;

			return 0;
		},
		getFavorites(){
			return this.favorites;
		}
	},
	actions: {
		setBasket(basket){
			this.basket = basket;
		},
		setFavorites(items){
			this.favorites = items;
		},
	},
});
